export default function Footer() {
  const navigation = {
    services: [
      { name: 'UI/UXデザイン', href: '#services' },
      { name: 'ブランディング', href: '#services' },
      { name: 'Webデザイン', href: '#services' },
      { name: 'モバイルアプリ', href: '#services' },
      { name: 'デザインシステム', href: '#services' },
      { name: 'クリエイティブディレクション', href: '#services' }
    ],
    company: [
      { name: 'About', href: '#about' },
      { name: 'Portfolio', href: '#portfolio' },
      { name: 'Blog', href: '#blog' },
      { name: 'Contact', href: '#contact' },
      { name: '採用情報', href: '#' }
    ],
    resources: [
      { name: 'デザインリソース', href: '#' },
      { name: 'ケーススタディ', href: '#' },
      { name: 'デザインガイド', href: '#' },
      { name: 'よくある質問', href: '#' }
    ],
    support: [
      { name: 'お問い合わせ', href: '#contact' },
      { name: 'プライバシーポリシー', href: '#' },
      { name: '利用規約', href: '#' }
    ]
  };

  const recentPosts = [
    { title: 'デザインシステムがもたらす組織変革', date: '2024年1月15日' },
    { title: 'ユーザーリサーチの実践方法', date: '2024年1月10日' },
    { title: 'アクセシビリティを考慮した設計', date: '2024年1月5日' }
  ];

  return (
    <footer className="relative bg-[#0a0a0a] text-[#f5f5f0] pt-20 pb-8">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZmlsdGVyIGlkPSJub2lzZSI+PGZlVHVyYnVsZW5jZSB0eXBlPSJmcmFjdGFsTm9pc2UiIGJhc2VGcmVxdWVuY3k9IjAuOSIgbnVtT2N0YXZlcz0iNCIgLz48L2ZpbHRlcj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWx0ZXI9InVybCgjbm9pc2UpIiBvcGFjaXR5PSIwLjAzIiAvPjwvc3ZnPg==')] opacity-50"></div>

      <div className="relative z-10 px-6 lg:px-12">
        <div className="border-t border-[#c9a96e]/20 pt-12 pb-8">
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <div>
              <h4 className="text-sm text-[#c9a96e] mb-4 font-medium">最近の投稿</h4>
              <ul className="space-y-3">
                {recentPosts.map((post, index) => (
                  <li key={index}>
                    <a
                      href="#blog"
                      className="group flex items-start gap-3 cursor-pointer"
                    >
                      <i className="ri-arrow-right-s-line text-[#c9a96e] mt-0.5 group-hover:translate-x-1 transition-transform duration-300"></i>
                      <div>
                        <div className="text-sm text-[#f5f5f0]/70 group-hover:text-[#c9a96e] transition-colors duration-300">
                          {post.title}
                        </div>
                        <div className="text-xs text-[#f5f5f0]/40 mt-1">{post.date}</div>
                      </div>
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm text-[#c9a96e] mb-4 font-medium">お問い合わせ</h4>
              <ul className="space-y-3">
                <li className="flex items-center gap-3 text-sm text-[#f5f5f0]/60">
                  <i className="ri-mail-line text-[#c9a96e]"></i>
                  <a href="mailto:hello@kenjitanaka.design" className="hover:text-[#c9a96e] transition-colors duration-300 cursor-pointer">
                    hello@kenjitanaka.design
                  </a>
                </li>
                <li className="flex items-center gap-3 text-sm text-[#f5f5f0]/60">
                  <i className="ri-phone-line text-[#c9a96e]"></i>
                  <a href="tel:+81-90-1234-5678" className="hover:text-[#c9a96e] transition-colors duration-300 cursor-pointer">
                    +81 90-1234-5678
                  </a>
                </li>
                <li className="flex items-start gap-3 text-sm text-[#f5f5f0]/60">
                  <i className="ri-map-pin-line text-[#c9a96e] mt-0.5"></i>
                  <span>東京都渋谷区神宮前3-25-18</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}